import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.concat.js";
/**
 *  Art Modal Manager
 *    Scripts to control the display of modals built from section blocks.
 *
 *  Version
 *    1.0.0 - 2021/09/16
 */

var SELECTOR_CONTAINER = '[data-modal-manager]';
var SELECTOR_MODAL = '[data-modal]';
var SELECTOR_CLOSE = '[data-modal-close]';
var SELECTOR_STEP_COUNT = '[data-modal-step-count]';
var SELECTOR_BTN_NEXT = '[data-modal-step-next]';
var SELECTOR_BTN_PREV = '[data-modal-step-previous]';
var SELECTOR_BTN_STEP_NUMBER = '[data-modal-step-number]';
var CLASS_MODAL_VISIBLE = 'is-modal-visible';
var CLASS_SCROLL_LOCK = 'has-scroll-lock';
var CLASS_ACTIVE = 'is-active';
var ATTR_MODAL_TRIGGER = 'data-modal-trigger';
var ATTR_MODAL_HANDLE = 'data-modal-handle';
var ATTR_STEP = 'data-modal-step';
var body = document.querySelector('body');
document.querySelectorAll(SELECTOR_CONTAINER).forEach(function (container) {
  var modals = document.querySelectorAll(SELECTOR_MODAL);

  //Close event listeners
  modals.forEach(function (modal) {
    var closeBtns = modal.querySelectorAll(SELECTOR_CLOSE);
    closeBtns.forEach(function (btn) {
      return btn.addEventListener('click', function (e) {
        return closeModal(e, modal);
      });
    });
    var steps = modal.querySelectorAll("[".concat(ATTR_STEP, "]"));
    var stepNumbers = modal.querySelectorAll(SELECTOR_BTN_STEP_NUMBER);
    var stepCount = modal.querySelector(SELECTOR_STEP_COUNT);
    var nextBtns = modal.querySelectorAll(SELECTOR_BTN_NEXT);
    var prevBtn = modal.querySelector(SELECTOR_BTN_PREV);
    if (!steps || !stepCount || !nextBtns || !prevBtn || !stepNumbers) return;
    nextBtns.forEach(function (btn) {
      return btn.addEventListener('click', function (e) {
        return onNextStepClick(e, steps, stepCount, stepNumbers);
      });
    });
    prevBtn.addEventListener('click', function (e) {
      return onPreviousStepClick(e, steps, stepCount, stepNumbers);
    });
    stepNumbers.forEach(function (button, i) {
      button.addEventListener('click', function (e) {
        return onStepNumberClick(e, steps, stepCount, stepNumbers, i);
      });
    });
  });

  //Open event listeners
  var triggerBtns = document.querySelectorAll("[".concat(ATTR_MODAL_TRIGGER, "]"));
  triggerBtns.forEach(function (btn) {
    return btn.addEventListener('click', function (e) {
      return openModal(e);
    });
  });
  function closeModal(e, modal) {
    // e.preventDefault();
    modal.classList.remove(CLASS_MODAL_VISIBLE);
    body.classList.remove(CLASS_SCROLL_LOCK);
  }
  function openModal(e) {
    e.preventDefault();
    var handle = e.currentTarget.getAttribute(ATTR_MODAL_TRIGGER);
    if (!handle) return;
    var modalArray = Array.from(modals);
    var modal = modalArray.find(function (m) {
      return m.getAttribute(ATTR_MODAL_HANDLE) === handle;
    });
    if (!modal) return;
    modal.classList.add(CLASS_MODAL_VISIBLE);
    body.classList.add(CLASS_SCROLL_LOCK);
  }
  function getCurrentStepIndex(steps) {
    var currentStep = Array.from(steps).findIndex(function (step) {
      return step.classList.contains(CLASS_ACTIVE);
    });
    if (currentStep === -1) throw 'Invalid markup detected in the modal steps';
    return currentStep;
  }
  function setActiveStep(activeIndex, steps, stepCount, stepNumbers) {
    var stepsArray = Array.from(steps);
    var stepNumbersArray = Array.from(stepNumbers);
    if (activeIndex < 0 || activeIndex >= stepsArray.length) return;
    stepsArray.forEach(function (step, i) {
      if (activeIndex === i) {
        step.classList.add(CLASS_ACTIVE);
      } else {
        step.classList.remove(CLASS_ACTIVE);
      }
    });
    stepNumbersArray.forEach(function (number, i) {
      console.log(number);
      if (activeIndex === i) {
        number.classList.add(CLASS_ACTIVE);
      } else {
        number.classList.remove(CLASS_ACTIVE);
      }
    });
    stepCount.innerHTML = "".concat(activeIndex + 1, " of ").concat(stepsArray.length);
  }
  function onNextStepClick(e, steps, stepCount, stepNumbers) {
    e.preventDefault();
    setActiveStep(getCurrentStepIndex(steps) + 1, steps, stepCount, stepNumbers);
  }
  function onPreviousStepClick(e, steps, stepCount, stepNumbers) {
    e.preventDefault();
    setActiveStep(getCurrentStepIndex(steps) - 1, steps, stepCount, stepNumbers);
  }
  function onStepNumberClick(e, steps, stepCount, stepNumbers, stepIndex) {
    e.preventDefault();
    setActiveStep(stepIndex, steps, stepCount, stepNumbers);
  }
});